import React from 'react';
import PropTypes from 'prop-types';

export default class PublicLinkURLContainer extends React.PureComponent {
  constructor(props) {
    super(props);

    this.copyLink = this.copyLink.bind(this);
    this.linkRef = React.createRef();
  }

  copyLink() {
    this.linkRef.current.select();
    document.execCommand('copy');
  }

  render() {
    const publicLinkURL = `${window.location.host}/self-serve-recipient-builder?documentType=${this.props.documentType}`;
    return (
      <div className="public-link-url-container">
        <input
          id="public-link"
          className="public-link-url"
          name="public_link"
          value={publicLinkURL}
          readOnly
          ref={this.linkRef}
        />
        <button className="public-link-copy-button" onClick={this.copyLink} >
          Copy Link
        </button>
      </div>
    );
  }
}

PublicLinkURLContainer.propTypes = {
  documentType: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/SelfServePostBuilderSidePanel/RecipientManager/PublicLinkURLContainer.jsx